// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rvtv","col":"styles_col__16mz8","actions":"styles_actions__12d6T","conflict":"styles_conflict__1Z9Pm"};